/* ============================================================
   MEGA MENU TABS - interaccion (THG / AdsHub)
   1. Tabs: cambia el panel al pasar el mouse.
   2. Carrusel: las flechas avanzan una pagina completa, o sea
      tantas tarjetas como se vean (4 en desktop, 3 o 2 en
      pantallas menores). Se ocultan si no hay hacia donde ir.
   ============================================================ */
(function () {

  /* ---- Carrusel: flechas + estado ---- */
  function initCarousel(carousel) {
    var track = carousel.querySelector('[data-thg-track]');
    var prev = carousel.querySelector('[data-thg-prev]');
    var next = carousel.querySelector('[data-thg-next]');
    if (!track) return;

    /* Cuantas tarjetas caben completas en el track ahora mismo */
    function visibleCount() {
      var card = track.querySelector('.thg-mm__card');
      if (!card) return 1;
      var w = card.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 20;
      if (!w) return 1;
      return Math.max(1, Math.round((track.clientWidth + gap) / (w + gap)));
    }

    /* Avanza una pagina completa: exactamente las tarjetas visibles */
    function scrollAmount() {
      var card = track.querySelector('.thg-mm__card');
      if (!card) return track.clientWidth;
      var w = card.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 20;
      return (w + gap) * visibleCount();
    }

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      var noScroll = track.scrollWidth <= track.clientWidth + 2;
      if (noScroll) {
        prev.setAttribute('disabled', '');
        next.setAttribute('disabled', '');
      } else {
        if (track.scrollLeft <= 0) prev.setAttribute('disabled', '');
        else prev.removeAttribute('disabled');
        if (track.scrollLeft >= maxScroll) next.setAttribute('disabled', '');
        else next.removeAttribute('disabled');
      }
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    /* actualizar cuando el panel se hace visible (mide bien) */
    carousel._thgUpdate = update;
    update();
  }

  /* ---- Subtitulo: se inyecta bajo el titulo de cada tarjeta ----
     card-product1 es un snippet compartido de Moxie, asi que en vez de
     modificarlo se agrega la linea desde aca usando el data-thg-sub que
     puso el liquid. */
  function initSubtitles(root) {
    root.querySelectorAll('[data-thg-sub]').forEach(function (wrap) {
      if (wrap.dataset.thgSubDone === '1') return;
      var text = wrap.getAttribute('data-thg-sub');
      if (!text) return;

      var card = wrap.querySelector('.thg-mm__card') || wrap;
      /* el titulo de Moxie: se busca por las clases mas probables */
      var title = card.querySelector(
        '.hdt-card-product__title, .hdt-pr-title, .hdt-product-title, h3 a, h3, h2 a, h2'
      );
      if (!title) return;

      var host = title.closest('h2, h3, .hdt-card-product__title, .hdt-pr-title') || title;
      host.classList.add('thg-mm__title--tight');

      var el = document.createElement('span');
      el.className = 'thg-mm__sub';
      el.textContent = text;
      host.insertAdjacentElement('afterend', el);
      wrap.dataset.thgSubDone = '1';
    });
  }

  /* ---- Tabs ---- */
  function initMegaMenuTabs(root) {
    var tabs = root.querySelectorAll('[data-thg-tab]');
    var panels = root.querySelectorAll('[data-thg-panel]');
    var carousels = root.querySelectorAll('[data-thg-carousel]');

    initSubtitles(root);
    carousels.forEach(initCarousel);

    function activate(handle) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-thg-tab') === handle;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-thg-panel') === handle;
        p.classList.toggle('is-active', on);
        if (on) {
          var c = p.querySelector('[data-thg-carousel]');
          if (c && c._thgUpdate) {
            /* el panel acaba de hacerse visible: medir en el siguiente frame */
            requestAnimationFrame(function () { c._thgUpdate(); });
          }
        }
      });
    }

    tabs.forEach(function (tab) {
      var handle = tab.getAttribute('data-thg-tab');
      tab.addEventListener('mouseenter', function () { activate(handle); });
      tab.addEventListener('click', function (e) { e.preventDefault(); activate(handle); });
    });
  }

  document.querySelectorAll('[data-thg-mm]').forEach(initMegaMenuTabs);
})();